import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GetActivityLogsDto } from "../../../../core/models/task-management/getActivityLogsDto";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { AccordionModule } from "primeng/accordion";
import { CommonModule } from "@angular/common";
import { TimelineModule } from "primeng/timeline";
import { CardModule } from "primeng/card";
import { SpinnerComponent } from "../../spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-activity-log",
  templateUrl: "./activity-log.component.html",
  styleUrls: ["./activity-log.component.scss"],
  imports: [AccordionModule, CommonModule, TimelineModule, CardModule, SpinnerComponent],
})
export class ActivityLogComponent implements OnInit {
  //events: any;
  display = false;
  showSmallLoader = true;
  showUpcomingSmallLoader = true;
  activityLogs: GetActivityLogsDto[] = [];

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit() {
    this.getActivityLogs();
  }

  getActivityLogs() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getActivityLogs()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.activityLogs = res.data || [];
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }
}
